import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

// Sprint UI-GLOBALE — avvisi della pagina in vista, raccolti per il centro avvisi.
const AvvisiContext = createContext(null);
export const GRAVITA = { info: 1, segnalazione: 2, critico: 3 };

export function AvvisiProvider({ children }) {
  const [avvisi, setAvvisi] = useState({});
  const metti = useCallback((id, a) => setAvvisi((p) => ({ ...p, [id]: a })), []);
  const togli = useCallback((id) => setAvvisi((p) => {
    if (!(id in p)) return p;
    const n = { ...p };
    delete n[id];
    return n;
  }), []);
  const value = useMemo(() => ({ avvisi: Object.entries(avvisi).map(([id, a]) => ({ id, ...a })), metti, togli }),
    [avvisi, metti, togli]);
  return <AvvisiContext.Provider value={value}>{children}</AvvisiContext.Provider>;
}

export const useAvvisiAttivi = () => useContext(AvvisiContext)?.avvisi || [];

// Pubblica un avviso nel centro avvisi finché `attivo` è vero e il componente è montato.
export function usePubblicaAvviso(id, { attivo = true, livello, testo, link }) {
  const ctx = useContext(AvvisiContext);
  const linkRef = useRef(link);
  linkRef.current = link;
  const linkLabel = link?.label || null;
  useEffect(() => {
    if (!ctx || !attivo) return undefined;
    ctx.metti(id, { livello, testo, link: linkLabel ? { label: linkLabel, onClick: () => linkRef.current?.onClick?.() } : null });
    return () => ctx.togli(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx?.metti, ctx?.togli, id, attivo, livello, testo, linkLabel]);
}
